import { Injectable } from '@angular/core';
import { DataCoreService, DlistDto, GetDlist_Request, GetDlist_Response} from '@dabnet-kamu/libs/ui';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@dabnet-kamu/libs/ui';
import { ControlConditionModel } from '../../../models/gen-control.model';
@Injectable()
export class GenMahalleCaddeSokakService {
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
    public gridControlsList$ = this._gridControlsList.asObservable();
    public belediyeCode : number;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
     constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}
  setParams(isReadOnly:boolean, isBindCheck:boolean){
    this.isReadOnly = isReadOnly;
    this.isBindCheck = isBindCheck;
  }

  getData(code: number,control:any, baseEntity?: string, isSetData?: boolean,controlCondition?:ControlConditionModel[]) {
     let dataSource: any;
     let tableName = "";
    const filterArr = [];
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
      dataSource.select(['Kod','MahalleKod','CaddeSokakKod','GenMahalleKoy.Ad', 'GenCaddeSokak.Ad','AktifEh']);
    } 
    else{
        dataSource = this.dataCoreService.getOData(baseEntity,['GenMahalleKoy','GenCaddeSokak']);
        dataSource.select(['Kod','MahalleKod','CaddeSokakKod','GenMahalleKoy.Ad', 'GenCaddeSokak.Ad','AktifEh']);
        if(controlCondition){
          controlCondition.forEach((item:any) => {
            filterArr.push([item.conditionColName, item.conditionColSymbol, item.conditionColText]);
          });
      }
    }

    filterArr.push(['Kod', '=', code]);
    //if (belediyeCode) filterArr.push(['BelediyeKod', '=', belediyeCode]);
    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }
}
